import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

// Formats a text input as currency while typing
// using IMask. Strips formatting before form
// submit so the server receives a clean number.
//
// Usage:
//   <div data-controller="currency-input">
//     <input data-currency-input-target="input" />
//   </div>
export default class extends Controller {
  static targets = ["input"]
  static values = {
    currency: { type: String, default: "MXN" },
    locale: { type: String, default: "en-US" },
  }

  connect() {
    const el = this.inputTarget

    // Resolve Intl symbols for the currency
    const parts = new Intl.NumberFormat(
      this.localeValue,
      { style: "currency", currency: this.currencyValue }
    ).formatToParts(1234.5)

    const currencySymbol = parts
      .find(p => p.type === "currency")?.value || "$"
    const group = parts
      .find(p => p.type === "group")?.value || ","
    const decimal = parts
      .find(p => p.type === "decimal")?.value || "."

    // Convert raw initial value to number for IMask
    const raw = parseFloat(
      el.value.replace(/[^0-9.\-]/g, "")
    )

    this.mask = IMask(el, {
      mask: `${currencySymbol}num`,
      blocks: {
        num: {
          mask: Number,
          thousandsSeparator: group,
          radix: decimal,
          mapToRadix: ["."],
          scale: 2,
          min: 0,
          max: 999_999_999,
          normalizeZeros: true,
          padFractionalZeros: true,
        },
      },
    })

    if (!isNaN(raw)) {
      this.mask.typedValue = raw
    }

    el.form?.addEventListener(
      "submit", this.stripFormatting
    )
  }

  disconnect() {
    this.inputTarget.form?.removeEventListener(
      "submit", this.stripFormatting
    )
    this.mask?.destroy()
  }

  stripFormatting = () => {
    this.inputTarget.value =
      this.mask.typedValue.toString()
  }
}
